<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span><span class="sm">CONTENTS</span></h1>
</header>
<p class="tocfm"><a class="xref" href="#/chiderridageschlecht0006#preface">Preface by Rodrigo Therezo</a></p>
<p class="tocfm"><a class="xref" href="#/chiderridageschlecht0007#editor">Editors’ Note</a></p>
<p class="tocpt"><a class="xref" href="#/chiderridageschlecht0008#ges"><span class="sm">GESCHLECHT</span> <span class="sm">III</span></a></p>
<p class="tocbmf"><a class="xref" href="#/chiderridageschlecht0014#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chiderridageschlecht0015#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-derrida-geschlecht-0005.vue?6c564998